import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const PRManagementContainer = styled.div({
  display: 'flex',
  flex: 1,
  width: '100%',
  marginTop: '20px',
})